import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Loading from "../molcules/Loading/Loading";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from "@mui/material/Button";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {get} from "./api";
import {
  Link, useHistory
} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    }
}));

export default function OrdersList({site}) {
  const history = useHistory();
  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (site) {
      setIsLoading(true);
      get(site).then(res => {
        setIsLoading(false);
        if (res.data) {
          setOrders(res.data)
        }
      }).catch(() => {
        setIsLoading(false);
      });
    }
  }, [site]);

  const rowClick = (event, row) => {
      history.push( `orders/${row._id}`);
  };

  return (
    <div>
      <div className="heading"><span className="heading-text">orders</span>
        <Link to="orders/create" className="head-action">
          <Button variant="outlined" color="primary" startIcon={<AddCircleOutlineIcon />}>New</Button>
        </Link>
      </div>
        {isLoading && <Loading/> }
        {!isLoading && !orders.length && <p>No order found, <Link to="orders/create">create order</Link>.</p>}
        {!isLoading && orders.length > 0 &&
        <Paper>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>

        <TableCell align="left">Date Time</TableCell>

        <TableCell align="left">Email</TableCell>

        <TableCell align="left">Site Id</TableCell>

        <TableCell align="left">Sale Type</TableCell>

        <TableCell align="left">Total Price</TableCell>

        <TableCell align="left">Tax</TableCell>

        <TableCell align="left">Collection Time</TableCell>

        <TableCell align="left">Employee Id</TableCell>

        <TableCell align="left">Sale Point</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((row, index) => (
                <TableRow key={index} hover onClick={event => rowClick(event, row)}>

        <TableCell align="left">{row.dateTime}</TableCell>

        <TableCell align="left">{row.email}</TableCell>

        <TableCell align="left">{row.siteId}</TableCell>

        <TableCell align="left">{row.saleType}</TableCell>

        <TableCell align="left">{row.totalPrice}</TableCell>

        <TableCell align="left">{row.tax}</TableCell>

        <TableCell align="left">{row.collectionTime}</TableCell>

        <TableCell align="left">{row.employeeId}</TableCell>

        <TableCell align="left">{row.salePoint}</TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>}
    </div>
  );
}
